import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSafe = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.518 4.77736L12.0242 2.625L5.5303 4.77736C5.04103 4.93956 4.61531 5.2518 4.3136 5.66972C4.01189 6.08765 3.84954 6.59002 3.84961 7.10548V12.4271C3.84961 18.5777 11.3702 21.9742 11.6923 22.1156L11.9817 22.2439L12.2825 22.1442C12.6062 22.0363 20.1987 19.4384 20.1987 12.4271V7.10548C20.1988 6.59002 20.0364 6.08765 19.7347 5.66972C19.433 5.2518 19.0073 4.93956 18.518 4.77736ZM12.3871 14.053C12.2442 14.1969 12.0742 14.3109 11.8868 14.3885C11.6995 14.4661 11.4986 14.5058 11.2958 14.5051H11.2688C11.0619 14.5019 10.8578 14.4568 10.6688 14.3725C10.4799 14.2882 10.3099 14.1665 10.1694 14.0146L8.28431 12.0527L9.4639 10.923L11.2983 12.8358L15.5335 8.6006L16.6894 9.75649L12.3871 14.053Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSafe);
export default ForwardRef;
